export const ADD_DAP_EXPORT_FILE_TO_MIGRATION_SUCCESS_DAP_EXPORT_FILE_IMPORTED =
    'europa.dap.migration.AddDapExportFileToMigration.DapExportFileImported';
export const ADD_DAP_EXPORT_FILE_TO_MIGRATION_FAILURE_UNEXPECTED_FAILURE =
    'europa.dap.migration.AddDapExportFileToMigration.UnexpectedFailure';
export const CREATE_DAP_MIGRATION_SUCCESS_DAP_MIGRATION_CREATED =
    'europa.dap.migration.CreateDapMigration.DapMigrationCreated';
export const CREATE_DAP_MIGRATION_FAILURE_UNEXPECTED_FAILURE =
    'europa.dap.migration.CreateDapMigration.UnexpectedFailure';
export const FETCH_DAP_MIGRATION_FILE_SUCCESS_DAP_MIGRATION_FILE_CONTENTS =
    'europa.dap.migration.FetchDapMigrationFile.DapMigrationFileContents';
export const FETCH_DAP_MIGRATION_FILE_FAILURE_UNEXPECTED_FAILURE =
    'europa.dap.migration.FetchDapMigrationFile.UnexpectedFailure';
export const LIST_DAP_MIGRATIONS_SUCCESS_DAP_MIGRATIONS =
    'europa.dap.migration.ListDapMigrations.DapMigrations';
export const LIST_DAP_MIGRATIONS_FAILURE_UNEXPECTED_FAILURE =
    'europa.dap.migration.ListDapMigrations.UnexpectedFailure';
export const START_FETCH_DAP_MIGRATION_FILES_SUCCESS_FETCH_DAP_MIGRATION_FILES_STARTED =
    'europa.dap.migration.StartFetchDapMigrationFiles.FetchDapMigrationFilesStarted';
export const START_FETCH_DAP_MIGRATION_FILES_FAILURE_UNEXPECTED_FAILURE =
    'europa.dap.migration.StartFetchDapMigrationFiles.UnexpectedFailure';
export const UPDATE_DAP_MIGRATION_SUCCESS_DAP_MIGRATION_UPDATED =
    'europa.dap.migration.UpdateDapMigration.DapMigrationUpdated';
export const UPDATE_DAP_MIGRATION_FAILURE_UNEXPECTED_FAILURE =
    'europa.dap.migration.UpdateDapMigration.UnexpectedFailure';
